<form [formGroup]="metadataFormGroup">
  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Date de début</label>
      <input type="date" class="form-control" formControlName="startDate" />
    </div>
    <div class="col">
      <label i18n>Durée du contrat</label>
      <input
        type="text"
        class="form-control"
        formControlName="contractDuration"
      />
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Mode de paiement</label>
      <select class="form-control" formControlName="paymentFrequency">
        <option *ngFor="let value of paymentFrequencyValues" [value]="value">
          {{ getPaymentFrequencyLabel(value) }}
        </option>
      </select>
    </div>
    <div class="col">
      <label i18n>Supplément pour paiement fractionné en %</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="splitPaymentFee"
      />
    </div>
  </div>

  <div class="row my-3">
    <div class="col">
      <label i18n>A subi des sinistres ces 5 dernières années</label>
      <div class="form-check">
        <input
          type="radio"
          name="hasclaimsLastFiveYears"
          id="hasclaimsLastFiveYearsFalse"
          [value]="false"
          formControlName="hasclaimsLastFiveYears"
        />
        <label class="form-check-label" for="hasclaimsLastFiveYearsFalse">
          Non
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasclaimsLastFiveYears"
          id="hasclaimsLastFiveYearsTrue"
          [value]="true"
          formControlName="hasclaimsLastFiveYears"
        />
        <label class="form-check-label" for="hasclaimsLastFiveYearsTrue">
          Oui
        </label>
      </div>
    </div>
  </div>

  <div
    class="row my-3"
    *ngIf="
      metadataFormGroup.value.hasclaimsLastFiveYears === 'true' ||
      metadataFormGroup.value.hasclaimsLastFiveYears === true
    "
  >
    <div class="col">
      <label i18n>Détails des sinistres</label>
      <textarea
        class="form-control"
        rows="3"
        formControlName="claims"
      ></textarea>
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Domages de tiers
  </div>
  <div formGroupName="thirdPartyDamages">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>RC pour les préjudices de fortune</label>
        <div class="form-check">
          <input
            type="radio"
            name="financialLossCivilResponsability"
            id="financialLossCivilResponsabilityFalse"
            [value]="false"
            formControlName="financialLossCivilResponsability"
          />
          <label
            class="form-check-label"
            for="financialLossCivilResponsabilityFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="financialLossCivilResponsability"
            id="financialLossCivilResponsabilityTrue"
            [value]="true"
            formControlName="financialLossCivilResponsability"
          />
          <label
            class="form-check-label"
            for="financialLossCivilResponsabilityTrue"
            >Oui</label
          >
        </div>
      </div>
      <div class="col">
        <label i18n>Somme d'assurance</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuranceSum"
        />
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n
          >Atteintes à la disponibilité de systèmes informatiques</label
        >
        <div class="form-check">
          <input
            type="radio"
            name="availabilityDamage"
            id="availabilityDamageFalse"
            [value]="false"
            formControlName="availabilityDamage"
          />
          <label class="form-check-label" for="availabilityDamageFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="availabilityDamage"
            id="availabilityDamageTrue"
            [value]="true"
            formControlName="availabilityDamage"
          />
          <label class="form-check-label" for="availabilityDamageTrue"
            >Oui</label
          >
        </div>
      </div>
      <div class="col">
        <label i18n>Pertes de données</label>
        <div class="form-check">
          <input
            type="radio"
            name="dataLoss"
            id="dataLossFalse"
            [value]="false"
            formControlName="dataLoss"
          />
          <label class="form-check-label" for="dataLossFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="dataLoss"
            id="dataLossTrue"
            [value]="true"
            formControlName="dataLoss"
          />
          <label class="form-check-label" for="dataLossTrue">Oui</label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n
          >Intervention illicite dans les systèmes informatiques
          (Hacking)</label
        >
        <div class="form-check">
          <input
            type="radio"
            name="hacking"
            id="hackingFalse"
            [value]="false"
            formControlName="hacking"
          />
          <label class="form-check-label" for="hackingFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="hacking"
            id="hackingTrue"
            [value]="true"
            formControlName="hacking"
          />
          <label class="form-check-label" for="hackingTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Violation de droits protégés</label>
        <div class="form-check">
          <input
            type="radio"
            name="piracy"
            id="piracyFalse"
            [value]="false"
            formControlName="piracy"
          />
          <label class="form-check-label" for="piracyFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="piracy"
            id="piracyTrue"
            [value]="true"
            formControlName="piracy"
          />
          <label class="form-check-label" for="piracyTrue">Oui</label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Violation de la protection des données</label>
        <div class="form-check">
          <input
            type="radio"
            name="privacyViolation"
            id="privacyViolationFalse"
            [value]="false"
            formControlName="privacyViolation"
          />
          <label class="form-check-label" for="privacyViolationFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="privacyViolation"
            id="privacyViolationTrue"
            [value]="true"
            formControlName="privacyViolation"
          />
          <label class="form-check-label" for="privacyViolationTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Violation des normes de sécurité des données PCI</label>
        <div class="form-check">
          <input
            type="radio"
            name="paymentDataViolation"
            id="paymentDataViolationFalse"
            [value]="false"
            formControlName="paymentDataViolation"
          />
          <label class="form-check-label" for="paymentDataViolationFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="paymentDataViolation"
            id="paymentDataViolationTrue"
            [value]="true"
            formControlName="paymentDataViolation"
          />
          <label class="form-check-label" for="paymentDataViolationTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Dommages propres
  </div>
  <div formGroupName="ownDamages">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Elimination des maliciels</label>
        <div class="form-check">
          <input
            type="radio"
            name="malwareRemoval"
            id="malwareRemovalFalse"
            [value]="false"
            formControlName="malwareRemoval"
          />
          <label class="form-check-label" for="malwareRemovalFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="malwareRemoval"
            id="malwareRemovalTrue"
            [value]="true"
            formControlName="malwareRemoval"
          />
          <label class="form-check-label" for="malwareRemovalTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n
          >Reconstitution ou récupération des données électroniques</label
        >
        <div class="form-check">
          <input
            type="radio"
            name="dataRetrieval"
            id="dataRetrievalFalse"
            [value]="false"
            formControlName="dataRetrieval"
          />
          <label class="form-check-label" for="dataRetrievalFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="dataRetrieval"
            id="dataRetrievalTrue"
            [value]="true"
            formControlName="dataRetrieval"
          />
          <label class="form-check-label" for="dataRetrievalTrue">Oui</label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Frais supplémentaires</label>
        <div class="form-check">
          <input
            type="radio"
            name="additionalFees"
            id="additionalFeesFalse"
            [value]="false"
            formControlName="additionalFees"
          />
          <label class="form-check-label" for="additionalFeesFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="additionalFees"
            id="additionalFeesTrue"
            [value]="true"
            formControlName="additionalFees"
          />
          <label class="form-check-label" for="additionalFeesTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Trafic électronique des paiements</label>
        <div class="form-check">
          <input
            type="radio"
            name="paymentProcessing"
            id="paymentProcessingFalse"
            [value]="false"
            formControlName="paymentProcessing"
          />
          <label class="form-check-label" for="paymentProcessingFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="paymentProcessing"
            id="paymentProcessingTrue"
            [value]="true"
            formControlName="paymentProcessing"
          />
          <label class="form-check-label" for="paymentProcessingTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Expéditions de marchandises</label>
        <div class="form-check">
          <input
            type="radio"
            name="shippingDamage"
            id="shippingDamageFalse"
            [value]="false"
            formControlName="shippingDamage"
          />
          <label class="form-check-label" for="shippingDamageFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="shippingDamage"
            id="shippingDamageTrue"
            [value]="true"
            formControlName="shippingDamage"
          />
          <label class="form-check-label" for="shippingDamageTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Perte de produit d'exploitation</label>
        <div class="form-check">
          <input
            type="radio"
            name="lossOperatingIncome"
            id="lossOperatingIncomeFalse"
            [value]="false"
            formControlName="lossOperatingIncome"
          />
          <label class="form-check-label" for="lossOperatingIncomeFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="lossOperatingIncome"
            id="lossOperatingIncomeTrue"
            [value]="true"
            formControlName="lossOperatingIncome"
          />
          <label class="form-check-label" for="lossOperatingIncomeTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Assistance
  </div>
  <div formGroupName="assistance">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Frais forensiques</label>
        <div class="form-check">
          <input
            type="radio"
            name="forensicsFee"
            id="forensicsFeeFalse"
            [value]="false"
            formControlName="forensicsFee"
          />
          <label class="form-check-label" for="forensicsFeeFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="forensicsFee"
            id="forensicsFeeTrue"
            [value]="true"
            formControlName="forensicsFee"
          />
          <label class="form-check-label" for="forensicsFeeTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n
          >Frais en relation avec la violation de la protection des
          données</label
        >
        <div class="form-check">
          <input
            type="radio"
            name="dataProtectionViolationFee"
            id="dataProtectionViolationFeeFalse"
            [value]="false"
            formControlName="dataProtectionViolationFee"
          />
          <label class="form-check-label" for="dataProtectionViolationFeeFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="dataProtectionViolationFee"
            id="dataProtectionViolationFeeTrue"
            [value]="true"
            formControlName="dataProtectionViolationFee"
          />
          <label class="form-check-label" for="dataProtectionViolationFeeTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Gestion de crise et mesures de réputation</label>
        <div class="form-check">
          <input
            type="radio"
            name="crisisManagement"
            id="crisisManagementFalse"
            [value]="false"
            formControlName="crisisManagement"
          />
          <label class="form-check-label" for="crisisManagementFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="crisisManagement"
            id="crisisManagementTrue"
            [value]="true"
            formControlName="crisisManagement"
          />
          <label class="form-check-label" for="crisisManagementTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n
          >Protection juridique lors de procédures administratives</label
        >
        <div class="form-check">
          <input
            type="radio"
            name="legalProtection"
            id="legalProtectionFalse"
            [value]="false"
            formControlName="legalProtection"
          />
          <label class="form-check-label" for="legalProtectionFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="legalProtection"
            id="legalProtectionTrue"
            [value]="true"
            formControlName="legalProtection"
          />
          <label class="form-check-label" for="legalProtectionTrue">Oui</label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Cyberchantage</label>
        <div class="form-check">
          <input
            type="radio"
            name="cyberBlackmail"
            id="cyberBlackmailFalse"
            [value]="false"
            formControlName="cyberBlackmail"
          />
          <label class="form-check-label" for="cyberBlackmailFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="cyberBlackmail"
            id="cyberBlackmailTrue"
            [value]="true"
            formControlName="cyberBlackmail"
          />
          <label class="form-check-label" for="cyberBlackmailTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Frais de négociation</label>
        <div class="form-check">
          <input
            type="radio"
            name="negociationFee"
            id="negociationFeeFalse"
            [value]="false"
            formControlName="negociationFee"
          />
          <label class="form-check-label" for="negociationFeeFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="negociationFee"
            id="negociationFeeTrue"
            [value]="true"
            formControlName="negociationFee"
          />
          <label class="form-check-label" for="negociationFeeTrue">Oui</label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Paiement de rançon</label>
        <div class="form-check">
          <input
            type="radio"
            name="ransomPayment"
            id="ransomPaymentFalse"
            [value]="false"
            formControlName="ransomPayment"
          />
          <label class="form-check-label" for="ransomPaymentFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="ransomPayment"
            id="ransomPaymentTrue"
            [value]="true"
            formControlName="ransomPayment"
          />
          <label class="form-check-label" for="ransomPaymentTrue">Oui</label>
        </div>
      </div>
    </div>

    <div class="row row-cols-1 mb-16">
      <div class="col">
        <label i18n>Somme d'assurance (CHF)</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuranceSum"
        />
      </div>
    </div>

    <div class="row row-cols-1">
      <div class="col">
        <label i18n>Franchise générale (CHF)</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="generalDeductible"
        />
      </div>
    </div>
  </div>
</form>
